import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-layout-introduction" }
const _hoisted_2 = { class: "my-5 md:py-12 space-y-8" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteIntroduction',
  props: {
    clouds: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_UContainer = _resolveComponent("UContainer")!
  const _component_MCloudsBottom = _resolveComponent("MCloudsBottom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UContainer, { class: "text-center max-w-2xl" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }),
    (__props.clouds)
      ? (_openBlock(), _createBlock(_component_MCloudsBottom, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})